module.exports = __webpack_public_path__ + "media/images/pwn-icon-daf7909cc5f3df61d94c4ed6045d1228.svg";